import { Injectable } from '@angular/core';
import { LogglyService } from 'ngx-loggly-logger';
import { ExceptionModel } from '../models/exception.model';
import { ApplicationMetaData } from '../constants/application-meta-data';
import * as Sentry from '@sentry/browser';
import * as LogRocket from 'logrocket';
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private sentry: any
  private logRocket: any
  constructor(private _logglyService: LogglyService) {
    // Init to set key and tag and sendConsoleErrors boolean
    this._logglyService.push({
      logglyKey: ApplicationMetaData.logglyToken,
      sendConsoleErrors: false,
      tag: ApplicationMetaData.logglyTagName,
    });
    this.sentry = Sentry;
    this.logRocket = LogRocket;
  }

  initLogger(): void {    
    this.logRocket.init(ApplicationMetaData.logRocketKey);
    this.sentry.init({
      dsn: ApplicationMetaData.SENTRY_DSN,
      // TryCatch has to be configured to disable XMLHttpRequest wrapping, as we are going to handle
      // http module exceptions manually in Angular's ErrorHandler and we don't want it to capture the same error twice.
      // Please note that TryCatch configuration requires at least @sentry/browser v5.16.0.
      integrations: [
        new Sentry.Integrations.TryCatch({
          XMLHttpRequest: false,
        }),
      ],
    });
    this.logRocket.getSessionURL((sessionURL) => {
      this.sentry.configureScope((scope) => {
        scope.setExtra('sessionURL', sessionURL);
      });
    });
  }

  /**
   * Log an exception that you have caught.
   * @param exceptionModel ExceptionModel
   * @param corelationId Corelation id
   */
  logException(exceptionModel: ExceptionModel, corelationId = null): void {
    if (corelationId) {
      exceptionModel.corelation_id = corelationId;
    }
    this._logglyService.push(exceptionModel);
  }

  /**
   * Log an exception that you have caught.
   * @param error error
   */
  logError(error: any): void {
    Sentry.captureException(error);
  }
  /**
   * Log rocket inentify user
   * @param user details
   */
  setUserIdentity(userDetails):void{
    this.logRocket.identify(userDetails.id,{
      name : userDetails.name,
      email: userDetails.email
    });
  }
}
